import Splide from '@splidejs/splide';

Drupal.behaviors.cardslider = {
  attach() {
    const cards = document.querySelectorAll('.card-slider .view-content-wrapper');
    cards.forEach((card) => {
      if (!card.classList.contains('card-slider--processed')) {
        const splide = new Splide(card, {
          type: 'slide',
          arrows: true,
          pagination: true,
          autoplay: false,
          perPage: 4,
          perMove: 1,
          speed: 1000,
          interval: 5000,
          rewind: false,
          gap: '2.5rem',
          breakpoints: {
            1000: {
              perPage: 2,
              gap    : '.7rem',
            },
            767: {
              perPage: 1,
              gap    : '.7rem',
            },
          },
        });
        splide.mount();
        card.classList.add('card-slider--processed');
      }
    });
  },
};
